// extracted by mini-css-extract-plugin
export default {"container":"AdminConfigClients_container__-w-S5"};